

let initStore = {
    facetLoading: false,
    facetError: false,
    svfacet_myloc:{
        my_esqueryText: "xx",
        my_dstqueryText:"yy",
        STARTDATE:"2023-10-24",
        ENDDATE: "2023-11-27" , 
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "+01:00",
        esqueryChilds:"m0",
        esqueryInfants:"i0",
        esqueryAdults:"t1",
        esqueryCabin:"ECONOMY",
        svpageSize:5


      },
    facetData: {
        //at start
        
        checkedAct1Label:'Boating',
        checkedAct1:true,
        disabledAct1:false,

        checkedAct2Label:'Fishing',
        checkedAct2:true,
        disabledAct2:false,

        checkedAct3Label:'Golf',
        checkedAct3:true,
        disabledAct3:false,

        checkedAct4Label:'Horse Riding',
        checkedAct4:true,
        disabledAct4:false,

        checkedAct5Label:'Tennis',
        checkedAct5:true,
        disabledAct5:false,

        checkedAct6Label:'Live Entertainment',
        checkedAct6:true,
        disabledAct6:false,

        //at end
        checkedLmDisneyLabel:'Disaney Springs',
        checkedLmDisney:true,
        disabledLmDisney:false,
         //svst start
         checkedStFiveLabel:'5 Stars',
         checkedStFive:true,
         disabledStFive:false,

         checkedStFourLabel:'4 Stars',
         checkedStFour:true,
         disabledStFour:false,

         checkedStThreeLabel:'3 Stars',
         checkedStThree:true,
         disabledStThree:false,

         checkedStTwoLabel:'2 Stars',
         checkedStTwo:true,
         disabledStTwo:false,
 

         //svst end
        //svrs start
        checkedRsExcellentLabel:'9+  Excellent',
        checkedRsExcellent:true,
        disabledRsExcellent:false,

        checkedRsGreatLabel:'8+ Great',
        checkedRsGreat:true,
        disabledRsGreat:false,

        checkedRsGoodLabel:'7+  Good',
        checkedRsGood:true,
        disabledRsGood:false,

        checkedRsOkayLabel:'5+ Okay',
        checkedRsOkay:true,
        disabledRsOkay:false,

        //svrs end

        //svfb start

        checkedFbCancellationLabel:'Free Cancellation',
        checkedFbCancellation:true,
        disabledFbCancellation:false,

        checkedFbInternetLabel:'Free Internet',
        checkedFbInternet:true,
        disabledFbInternet:false,


        checkedFbParkingLabel:'Free Parking',
        checkedFbParking:true,
        disabledFbParking:false,



        checkedFbBreakfastLabel:'Free Nreakfast',
        checkedFbBreakfast:true,
        disabledFbBreakfast:false,

        //svfb end

        minBudgetPrice:20,
        maxBudgetPrice:800,
        valueSlider:100,

        checkedParkingLabel:'Free Parking',
        checkedParking:true,
        disabledParking:false,

        checkedWifiLabel:'Wifi',
        checkedWifi:true,
        disabledWifi:false,

        checkedRestaurantLabel:'Restaurant',
        checkedRestaurant:true,
        disabledRestaurant:false,

        checkedPetfriendlyabel:'pet Friendlly',
        checkedPetfriendly:true,
        disabledPetfriendly:false,

        checkedRoomserviceLabel:'Room Service',
        checkedRoomservice:true,
        disabledRoomservice:false,

        checkedFrontdeskLabel:'24 Hours Front Desk',
        checkedFrontdesk:true,
        disabledFrontdesk:false,

        checkedFitnessLabel:'Fitness Center',
        checkedFitness:true,
        disabledFitness:false,

        checkedNonsmokingLabel:'Non Smoking',
        checkedNonsmoking:true,
        disabledNonsmoking:false,

        checkedShuttleLabel:'Airport Shuttle',
        checkedShuttle:true,
        disabledShuttle:false,

        checkedFamilyroomsLabel:'Family Room',
        checkedFamilyrooms:true,
        disabledFamilyrooms:false,

        checkedSpaLabel:'Spa',
        checkedSpa:true,
        disabledSpa:false,

        checkedEvchargingLabel:'Electric Vehicle(EV) Charging',
        checkedEvcharging:true,
        disabledEvcharging:false,

        checkedWheelchairLabel:'Wheel Chair Accessibility',
        checkedWheelchair:true,
        disabledFWheelchair:false,

        checkedPoolLabel:'Swimming Pool',
        checkedPool:true,
        disabledPool:false

      
    }
}



export default (store = initStore, action) => {

    console.log(action);

    switch (action.type) {
        case "facet/SOJOURNS_LIST":
            console.log('tasks LIST_SOJOURNS reducer')
            return { ...store, facetData: action.payload.facetData, facetLoading: false, facetError: null }
        case "facet/SOJOURNS_BEGIN":
        
            return { ...store, facetData: [], facetLoading: true, facetError: null }
        case "facet/SOJOURNS_ERROR":
            return { ...store, facetData: [], facetError: action.error, facetLoading: false }
        case  "facet/SOJOURNS_SUCCESS":
            if(action.payload.svfacet_myloc){
                return { ...store,svfacet_myloc:action.payload.svfacet_myloc, facetData: action.payload.facetData, facetLoading: false}
 
            }else{
                return { ...store, facetData: action.payload.facetData, facetLoading: false}
 
            }
                       default:
            return store
    }
}